<template>
  <div class="no-overscroll" ref="storyMenu" style="overflow-y: auto; position: relative;">
      <div v-for="episode in episodes" :key="episode.id">
        <div ref="myHeader" :class="{sticky : episode.id === 1}" v-if="episode.id <= episodeProgress || isFinished">
          <h1 class="menu-label" v-if="episode.id < episodeProgress || chapterProgress > 1 || isFinished">{{episodeTitle(episode.id)}} - {{episode.title}}</h1>
          <ul class="menu-list">
            <li v-for="chapter in episode.chapters" :key="chapter.id">
              <div v-if="chapter.id < chapterProgress || episode.id < episodeProgress || isFinished">
                <router-link :to="'/chapter/' + episode.id + '/' + chapter.id" class="menu-label">{{chapterTitle(chapter.id)}}</router-link>
                <ul class="menu-list">
                  <li v-for="(story, key) in chapter.titles" :key="key">
                    <router-link :class="{'is-active' : story === currentPage}" :to="'/story/' + episode.id + '/' + chapter.id + '/' + key">{{story}}</router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'UnlockingContents',

  data () {
    return {
      episodes: this.$root.config.episodes,
      animated: false
    }
  },
  computed: {
    episodeProgress () {
      return this.$store.state.progress.episode
    },
    chapterProgress () {
      return this.$store.state.progress.chapter
    },
    isFinished () {
      return this.$root.progress.finished
    }
  },
  props: {
    currentPage: String
  },
  methods: {
    episodeTitle (id) {
      var num
      if (id === 1) {
        num = 'I'
      } else if (id === 2) {
        num = 'II'
      } else if (id === 3) {
        num = 'III'
      } else if (id === 4) {
        num = 'IV'
      } else if (id === 5) {
        num = 'Five'
      }
      return 'Episode ' + num
    },
    chapterTitle (id) {
      var num
      if (id === 1) {
        num = 'One'
      } else if (id === 2) {
        num = 'Two'
      } else if (id === 3) {
        num = 'Three'
      } else if (id === 4) {
        num = 'Four'
      } else if (id === 5) {
        num = 'Five'
      }
      return 'Chapter ' + num
    }/* ,
    myFunction () {
      var headers = this.$refs.myHeader
      var menuScrolled = this.$refs.storyMenu.scrollTop
      for (var i = headers.length - 1; i >= 0; i--) {
        if (typeof headers[i + 1] !== 'undefined') {
          if (headers[i].offsetTop + 0 < menuScrolled && (headers[i + 1].offsetTop) > menuScrolled) {
            headers[i].classList.add('sticky')
          } else {
            headers[i].classList.remove('sticky')
          }
        } else if (headers[i].offsetTop + 0 < menuScrolled) {
          headers[i].classList.add('sticky')
        } else {
          headers[i].classList.remove('sticky')
        }
      }
    }
  },
  mounted () {
    this.$refs.storyMenu.addEventListener('scroll', this.myFunction) */
  }
}
</script>

<style lang="css" scoped>
h1 {
  width: 100%;
  background: black;
  padding: 5px;
  color: white;
}
h1 {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  display: block;
}
.sticky > .menu-list {
}
</style>
